module.exports = __webpack_public_path__ + "img/rdd.673ad4b6.svg";